import React from 'react'
// import Loader from '../../Loader/Loader'
// import { useDispatch, useSelector } from 'react-redux'
import "../../../styles/updateStyle.css"
// import { getNotification, markAsReadNotification } from '../../services/operations/ResumeAPI'

const Notification = () => {

    // const [notifications, setNotifications] = useState({});
    // const loading = useSelector((state) => state.auth.loading)
    // const token = useSelector((state) => state.auth.token)
    // const dispatch = useDispatch();


    // const getAllNotification = async () => {
    //     const result = await dispatch(getNotification(token))

    //     if (result?.data?.notifications) {
    //         const flat = Object.entries(result.data.notifications).flatMap(
    //             ([date, items]) =>
    //                 items.map((item) => ({
    //                     ...item,
    //                     date,
    //                 }))
    //         );
    //         setNotifications(flat);
    //     }
    //     else {
    //         setNotifications({})
    //     }

    // }

    // const handleMarkRead = async () => {
    //     await dispatch(markAsReadNotification(token));
    //     setNotifications({});
    // };

    // function timeAgo(dateString) {
    //     const createdDate = new Date(dateString);
    //     const now = new Date();
    //     const seconds = Math.floor((now - createdDate) / 1000);

    //     if (seconds < 60) return `${seconds}s ago`;
    //     const minutes = Math.floor(seconds / 60);
    //     if (minutes < 60) return `${minutes}m ago`;
    //     const hours = Math.floor(minutes / 60);
    //     if (hours < 24) return `${hours}h ago`;
    //     const days = Math.floor(hours / 24);
    //     if (days < 30) return `${days}d ago`;
    //     const months = Math.floor(days / 30);
    //     if (months < 12) return `${months}mo ago`;
    //     const years = Math.floor(months / 12);
    //     return `${years}y ago`;
    // }


    // useEffect(() => {
    //     getAllNotification();
    //     const timer = setInterval(() => {
    //         getAllNotification();
    //     }, 30000);

    //     return () => clearInterval(timer);
    // }, [])


    // const renderMessage = (message) => {
    //     if (message.startsWith("Upload progress:")) {
    //         const lines = message
    //             .replace("Upload progress:", "")
    //             .split(",")
    //             .map((line) => line.trim())
    //             .filter(Boolean);

    //         return (
    //             <div className='notificaiton-container'>
    //                 <p style={{ fontSize: "20px" }}>
    //                     Upload progress
    //                 </p>
    //                 <ul>
    //                     {lines.map((line, i) => (
    //                         <li key={i}>{line}</li>
    //                     ))}
    //                 </ul>
    //             </div>
    //         );
    //     }
    //     return <p>{message}</p>;
    // };

    return (
        <div
            className="jobpost-dashboard"
            style={{ minHeight: "100vh", padding: "20px", marginTop: "91px" }}
        >
            {/* {loading && <Loader />} */}
            {/* <div className="notification-header">
                <p>
                    Notifications{" "}
                    {notifications?.length > 0 ? `(${notifications.length})` : "(0)"}
                </p>
                <button onClick={handleMarkRead}>Mark All As Read</button>
            </div>
            {notifications.length > 0 ? (
                notifications.map((not, index) => (
                    <div key={index} className="notification-message">
                        {renderMessage(not.message)}
                        <p className="created-at">
                            {not.created_at ? timeAgo(not.created_at) : not.date}
                        </p>
                    </div>
                ))
            ) : (
                <p className="notification-no-list">No notifications as of now!</p>
            )} */}
             <p className="notification-no-list">Coming Soon</p>
        </div>

    )
}

export default Notification